const rangeInputs = document.querySelectorAll('.js-range-input');
const priceInputs = document.querySelectorAll('.js-price-input');
const range = document.querySelector('.js-progress-bar');
const rangeInput = document.querySelector(".k-range-slider__input");
let clientId = null;
const minGap = 10;

if(rangeInput)
  clientId = rangeInput.dataset.buttonId;

if(rangeInputs && range)
{
  const min = parseInt(rangeInputs[0].min, 10);
  const minVal = parseInt(rangeInputs[0].value, 10);
  const max = parseInt(rangeInputs[1].max, 10);
  const maxVal = parseInt(rangeInputs[1].value, 10);

  const minValue = (minVal - min) / (max - min) * (100 - 0) + 0; // (6 - 5) / (11 - 5) * (100 - 0) + 0;
  const maxValue = (maxVal - min) / (max - min) * (100 - 0) + 0; // (6 - 5) / (11 - 5) * (100 - 0) + 0;

  range.style.left = `${minValue}%`;
  range.style.right = `${100 - maxValue}%`;
}

let timeout = null;

priceInputs.forEach((input) =>
{
  input.addEventListener('input', (e) =>
  {
    const minPrice = parseInt(priceInputs[0].value, 10);
    const maxPrice = parseInt(priceInputs[1].value, 10);

    if ((maxPrice - minPrice >= minGap) && maxPrice <= rangeInputs[1].max)
    {
      if (e.target.classList.contains('js-price-input--min'))
      {
        rangeInputs[0].value = minPrice;
        range.style.left = `${(minPrice / rangeInputs[0].max) * 100}%`;
      }
      else
      {
        rangeInputs[1].value = maxPrice;
        range.style.right = `${100 - (maxPrice / rangeInputs[1].max) * 100}%`;
      }
    }

    clearTimeout(timeout);

    timeout = setTimeout(function()
    {
      __doPostBack(clientId, 'OnClick');
    }, 400);
  });
});

rangeInputs.forEach((input) =>
{
  input.addEventListener('input', (e) =>
  {
    const minVal = parseInt(rangeInputs[0].value, 10);
    const maxVal = parseInt(rangeInputs[1].value, 10);

    if ((maxVal - minVal) < minGap)
    {
      if (e.target.classList.contains('js-range-input--min'))
        rangeInputs[0].value = maxVal - minGap;
      else
        rangeInputs[1].value = minVal + minGap;
    }
    else
    {
      priceInputs[0].value = minVal;
      priceInputs[1].value = maxVal;

      const min = parseInt(rangeInputs[0].min, 10);
      const max = parseInt(rangeInputs[1].max, 10);

      const minValue = (minVal - min) / (max - min) * (100 - 0) + 0; // (6 - 5) / (11 - 5) * (100 - 0) + 0;
      const maxValue = (maxVal - min) / (max - min) * (100 - 0) + 0; // (6 - 5) / (11 - 5) * (100 - 0) + 0;

      range.style.left = `${minValue}%`;
      range.style.right = `${100 - maxValue}%`;
    }
  });

  input.addEventListener("change", (e) =>
  {
    clearTimeout(timeout);

    __doPostBack(clientId, 'OnClick');
  });
});
